import axios, { AxiosResponse } from 'axios';

import { CustomerRequest, SuccessResponse } from '../../../types';

import {
  ChangePasswordParam,
  LoginApiResponse,
  LoginParam,
  RefreshTokenParam,
  VerifyEmailParam,
  VerifyEmailResponse,
} from './auth.state';

import Config from 'config';

interface VerifyIdpCodeParam {
  code: string;
  email?: string;
  sandbox?: boolean;
}

export class AuthService {
  async signup(payload: CustomerRequest): Promise<AxiosResponse<SuccessResponse>> {
    return axios.post<SuccessResponse>(`${Config.SERVER_URL}/customers/create`, payload);
  }

  async login(payload: LoginParam): Promise<AxiosResponse<LoginApiResponse>> {
    return axios.post<LoginApiResponse>(`${Config.SERVER_URL}/auth/login`, payload);
  }

  async verifyIdpCode(payload: VerifyIdpCodeParam): Promise<AxiosResponse<LoginApiResponse>> {
    return axios.post<LoginApiResponse>(`${Config.SERVER_URL}/auth/verifyIdpCode`, payload);
  }

  async loginMicrosoft(accessToken: string): Promise<AxiosResponse<LoginApiResponse>> {
    return axios.post(`${Config.SERVER_URL}/auth/sso/microsoft`, { accessToken });
  }

  async refreshToken(params: RefreshTokenParam): Promise<AxiosResponse<LoginApiResponse>> {
    return axios.post<LoginApiResponse>(`${Config.SERVER_URL}/auth/refreshToken`, null, { params });
  }

  async resendVerifyEmail(payload: VerifyEmailParam): Promise<AxiosResponse<VerifyEmailResponse>> {
    return axios.post<VerifyEmailResponse>(`${Config.SERVER_URL}/auth/requestVerifyEmail`, payload);
  }

  async changePassword(data: ChangePasswordParam): Promise<void> {
    await axios.post(`${Config.SERVER_URL}/auth/changePassword`, data);
  }
}

export default new AuthService();
